import { requireDashboardOrigin } from "@api/auth/dashboardOriginGuard"
import { requireDashboardAuth } from "@api/auth/requireDashboardAuth"
import { contentTypeNameSchema } from "@content-types"
import { serverRouteConfig } from "@lib/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const presignInputSchema = z.object({
  contentType: contentTypeNameSchema,
  fileName: z.string().min(1).max(180),
  mimeType: z.string().min(1).max(100),
  size: z.number().int().positive(),
})

export const Route = createFileRoute("/api/dashboard/assets/presign")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          const auth = await requireDashboardAuth(request, ["admin", "editor"])
          if ("response" in auth) return auth.response

          try {
            const input = presignInputSchema.parse(await request.json())
            const { createDashboardAssetUploadData } = await import("@api/services/dashboardAssets")
            return Response.json(await createDashboardAssetUploadData(input))
          } catch (error) {
            return Response.json(
              { error: error instanceof Error ? error.message : "Could not create upload URL" },
              { status: 400 }
            )
          }
        },
      },
    },
  })
)
